import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Planning.module.css';
import "./ReactBigCalendarReset.css";
import { Calendar } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';

const PlanningLegend = props => {
    let legends = [];
    
    if (!props || !props.legend) {
        return null;
    }

    for (let i = 0; i < props.legend.length; i++) {
        const legend = props.legend[i];

        const legendElement = <li className={styles.legendLi} key={i}>
            <span style={{backgroundColor: legend.color, width: "1rem", height: "1rem", borderRadius: "50%", display: "flex", alignItems: "center", flexDirection: "row", justifyContent: "center"}} className={styles.legendColor}></span>
            <span style={{color: legend.color}}>{legend.label}</span>
        </li>
        legends.push(legendElement);
    }

    return (
        <div className={styles.planningLegend}>
            <ul className={styles.legendUl}>
                {legends}
            </ul>
        </div>
    );
}

export default PlanningLegend;
